import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import { Box, Button, Callout, CloseButton, Row } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useStore, useStoreActions } from '~/contexts';
import { useCreateVendorAccount } from '~/hooks/useCreateVendorAccount/useCreateVendorAccount';
import { useLocaleKeys } from '~/i18n';
import { selectors } from '~/store/state-selectors';
import styles from './HomePage.module.scss';
export const GetAnchorForBusinessBannerTID = (parentTestId)=>getTestIds(parentTestId);
export function AnchorForBusinessBanner() {
    const { t: homeTexts } = useLocaleKeys('home.homePage');
    const { AnchorForBusinessBannerTID } = useMemo(()=>GetAnchorForBusinessBannerTID(), []);
    const isClient = useStore(selectors.user.isClient);
    const isVendor = useStore(selectors.user.isVendor);
    const isViewMode = useStore(selectors.isViewMode);
    const hasAVendorAccount = useStore((state)=>{
        var _state_userInfo;
        return (_state_userInfo = state.userInfo) === null || _state_userInfo === void 0 ? void 0 : _state_userInfo.hasAVendorAccount();
    });
    const userClientData = useStore((state)=>state.userClientData);
    const { updateUserClientData, logBI } = useStoreActions();
    const onCreateVendorAccount = useCreateVendorAccount(()=>logBI(19201));
    const [isDismissed, setIsDismissed] = useState((userClientData === null || userClientData === void 0 ? void 0 : userClientData.anchorForBusinessBannerDismissed) === true);
    useEffect(()=>{
        setIsDismissed((userClientData === null || userClientData === void 0 ? void 0 : userClientData.anchorForBusinessBannerDismissed) === true);
    }, [
        userClientData === null || userClientData === void 0 ? void 0 : userClientData.anchorForBusinessBannerDismissed
    ]);
    const shouldShow = useMemo(()=>isClient && !isVendor && !hasAVendorAccount && !isDismissed && !isViewMode, [
        isClient,
        isVendor,
        hasAVendorAccount,
        isDismissed,
        isViewMode
    ]);
    useEffect(()=>{
        if (shouldShow) {
            logBI(19200);
        }
    }, [
        shouldShow
    ]);
    const handleDismiss = async ()=>{
        logBI(19202);
        setIsDismissed(true);
        await updateUserClientData({
            anchorForBusinessBannerDismissed: true
        });
    };
    if (!shouldShow) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Box, {
        className: styles.anchorForBusinessBannerContainer,
        children: /*#__PURE__*/ _jsx(Callout, {
            hideIcon: true,
            intent: "info",
            testId: AnchorForBusinessBannerTID.Root(),
            classes: {
                wrapper: styles.anchorForBusinessBannerWrapper,
                main: styles.anchorForBusinessBannerMain
            },
            withAction: /*#__PURE__*/ _jsxs(Row, {
                alignItems: "center",
                gap: 8,
                className: styles.anchorForBusinessBannerButtons,
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        size: "small",
                        testId: AnchorForBusinessBannerTID.GetStartedButton(),
                        skin: "primary",
                        onClick: onCreateVendorAccount,
                        bi: {
                            name: 'get_started_free'
                        },
                        children: homeTexts.getStartedForFree()
                    }),
                    /*#__PURE__*/ _jsx(CloseButton, {
                        onClick: handleDismiss,
                        testId: AnchorForBusinessBannerTID.DismissButton(),
                        bi: {
                            name: 'dismiss_banner'
                        }
                    })
                ]
            }),
            children: homeTexts.anchorForBusinessDescription()
        })
    });
}
